import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/History.svg?component
var History_exports = /* @__PURE__ */ __exportAll({
	default: () => History_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M12.9 6.8v6.1h4.7" }, null, -1), createElementVNode("path", { d: "M6.1 17.2c1.6 2.2 4.2 3.6 7.1 3.6 4.8 0 8.8-3.9 8.8-8.8s-3.9-8.8-8.8-8.8-8.8 4-8.8 8.8v1.7M2 11.3l2.4 2.4 2.4-2.4" }, null, -1)])]);
}
var History_default = { render: render$1 };
//#endregion
export { History_exports, History_default as default, render$1 as render };

//# sourceMappingURL=History.svg.virtual.js.map